import buildShortTextQuestiom from "./questions/ShortTextQuestion";
import buildParagraphQuestion from "./questions/ParagraphQuestion";
import buildMultiChoiceRadioQuestion from "./questions/MultiChoiceRadioQuestion";
import buildMultiChoiceCheckQuestion from "./questions/MultiChoiceCheckQuestion";
import buildMultiChoiceDropdownQuestion from "./questions/MultiChoiceDropdownQuestion";
import buildDateQuestion from "./questions/DateQuestion";
import buildTimeQuestion from "./questions/TimeQuestion";

// Circular with the three MultiChoice*Question modules above (they call
// buildControl back, to render nested sub-questions) - safe here because
// the call only ever happens inside a function body at render time, well
// after every module involved has finished loading.
const buildControl = (question) => {
  switch (question.QuestionType) {
    case "ShortTextQuestion":
      return buildShortTextQuestiom(question);
    case "ParagraphQuestion":
      return buildParagraphQuestion(question);
    case "MultiChoiceRadioQuestion":
      return buildMultiChoiceRadioQuestion(question);
    case "MultiChoiceCheckQuestion":
      return buildMultiChoiceCheckQuestion(question);
    case "MultiChoiceDropdownQuestion":
      return buildMultiChoiceDropdownQuestion(question);
    case "DateQuestion":
      return buildDateQuestion(question);
    case "TimeQuestion":
      return buildTimeQuestion(question);
    default:
      break;
  }
};

export default buildControl;
